import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../../less/result-list.less';
export const ExamResults = (props) => {
    const { exam, maximumQuestions, lastCompletedExam, language, isLaw2022Student, examTechnicalError } = props;
    const [questionScores, setQuestionScores] = useState([]);
    const hasScores = maximumQuestions > 0 && exam.questionScores;
    useEffect(() => {
        if (exam && exam.questionScores)
            setQuestionScores(exam.questionScores.flatMap(score => score).map(score => score.weightedScore));
    }, [exam]);
    return (React.createElement("tr", { className: getExamResultRowClassName(exam, lastCompletedExam) },
        React.createElement("td", { className: "exam-code" },
            React.createElement("b", null, exam.examCode)),
        React.createElement("td", { className: "exam-name" }, language === 'sv' ? exam.nameSwedish : exam.nameFinnish),
        React.createElement("td", { className: "exam-required" }, getMandatory(exam, isLaw2022Student)),
        React.createElement("td", { className: "exam-gradecode" }, exam.gradecodeCode ? React.createElement("strong", null, exam.gradecodeCode) : '-'),
        React.createElement("td", { className: "exam-score" }, getExamScore(exam)),
        hasScores &&
            Array(maximumQuestions)
                .fill(undefined)
                .map((__, index) => (React.createElement("td", { key: index, className: "question-score" }, getQuestionScore(questionScores, index)))),
        React.createElement("td", { colSpan: !hasScores ? maximumQuestions + 1 : undefined },
            React.createElement("span", { className: "exam-technical-error" }, getTechnicalError(examTechnicalError)),
            React.createElement("span", { className: "exam-status" }, getExamStatus(exam)),
            React.createElement("span", { className: "exam-grade-points" }, getExamGradePoints(exam)))));
};
const getMandatory = (exam, isLaw2022Student) => {
    const { t } = useTranslation();
    if (isLaw2022Student)
        return null;
    if (exam.mandatory)
        return t('results.mandatory_exam_short');
    return t('results.extra_exam_short');
};
const getExamGradePoints = (exam) => {
    if (exam.compensationInfo) {
        return React.createElement("strong", null, exam.gradePoints);
    }
    return React.createElement("strong", null, exam.isBestGrade && exam.gradePoints ? exam.gradePoints : '-');
};
const getExamStatus = (exam) => {
    const { t } = useTranslation();
    const statusInfo = [];
    if (exam.invalidated) {
        return t('results.invalidated');
    }
    if (exam.aborted) {
        return t('results.aborted');
    }
    if (exam.compensationInfo) {
        statusInfo.push(exam.compensationInfo.compensated
            ? `${t('results.compensated')} (min ${exam.compensationInfo.requiredCompensationPoints}${t('results.points')})`
            : t('results.not_compensated'));
    }
    if (exam.gradeRaised) {
        statusInfo.push(t('results.grade_raised'));
    }
    return statusInfo.length > 0 ? `${statusInfo.join(', ')}` : null;
};
const getExamScore = (exam) => {
    if (!exam.maxScore || !exam.questionScores)
        return '-';
    return `${exam.finalGradeScore || '-'}/${exam.maxScore}`;
};
const getTechnicalError = (technicalError) => {
    const { t } = useTranslation();
    if (technicalError) {
        return `${t('results.technical_error')} (${technicalError.technicalErrorPoints})`;
    }
    return null;
};
const getQuestionScore = (questionScores, index) => {
    if (index >= questionScores.length)
        return '';
    if (questionScores[index] === null)
        return '-';
    return questionScores[index];
};
const getExamResultRowClassName = (exam, lastCompletedExam) => {
    const isNotBestGradeClassName = !exam.isBestGrade ? 'not-best-result' : undefined;
    if (!lastCompletedExam) {
        return isNotBestGradeClassName;
    }
    return isNotBestGradeClassName ? `${isNotBestGradeClassName} last-completed-exam` : 'last-completed-exam';
};
//# sourceMappingURL=exam-results.js.map